import { render, staticRenderFns } from "./housemaid-policy-form.vue?vue&type=template&id=5ef0abf2&scoped=true&"
import script from "./housemaid-policy-form.vue?vue&type=script&lang=js&"
export * from "./housemaid-policy-form.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-policy-form.vue?vue&type=style&index=0&id=5ef0abf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0abf2",
  null
  
)

export default component.exports